module.exports = __webpack_public_path__ + "img/miracum_project.08da587c.png";